<template>
  <div class="table">
    <div class="container">
      <div class="handle-box" style="padding-bottom: 10px">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="right" label-width="120px">
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('material.eightBitCode')" prop="eightBitCode">
                <el-input v-model="queryCondition.eightBitCode" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('material.eightBitCodeName')" prop="eightBitCodeName">
                <el-input v-model="queryCondition.eightBitCodeName" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工厂编号" prop="plantNo">
                <el-input v-model="queryCondition.plantNo" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工厂名称" prop="plantName">
                <el-input v-model="queryCondition.plantName" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="供应商编号" prop="supplierCode">
                <el-input v-model="queryCondition.supplierCode" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="供应商名称" prop="supplierName">
                <el-input v-model="queryCondition.supplierName" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="DC" prop="dcName">
                <el-input v-model="queryCondition.dcName" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="温区" prop="temperature">
                <ic-select table="COMMON" class="handle-input" field="TEMPERATURE" v-model="queryCondition.temperature"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button class="btn" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button type="primary" @click="clickSelectMethod">{{$t('common.select')}}</el-button>
      </el-row>
      <el-table :data="tableData" border highlight-current-row class="table">
        <el-table-column width="30" align="center">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getTemplateRow(scope.row)" :label="scope.row.tmMaterialId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="100px" prop="eightBitCode" sortable :label="$t('material.eightBitCode')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="eightBitCodeName" sortable :label="$t('material.eightBitCodeName')"></el-table-column>
        <el-table-column show-overflow-tooltip width="100px" prop="plantNo" sortable label="工厂编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="plantName" sortable label="工厂名称"></el-table-column>
        <el-table-column show-overflow-tooltip width="100px" prop="supplierCode" sortable label="供应商编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierName" sortable label="供应商名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="dcName" sortable label="DC"></el-table-column>
        <el-table-column show-overflow-tooltip width="60px" prop="temperatureI18n" sortable label="温区"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import commonFunction from "../../../utils/dataTableUtils"
import { materialService } from "../../../api/base-data/material";
import IcSelect from "@/components/common/icSelect";
import SelDc from '../base-data/dc-sel-page'
import { Message } from "element-ui";
import dataTableUtils from "../../../utils/dataTableUtils";
export default {
  name: 'material',
  components: { IcSelect, SelDc },
  data() {
    return {
      tableData: [],
      totalCount: 0,
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        eightBitCode: null,
        eightBitCodeName: null,
        plantNo: null,
        plantName: null,
        supplierCode: null,
        supplierName: null,
        pickupPoint: null,
        dcName: null,
        temperature: null,
        transportaionMethod: null
      },
      selectRows: [],
      radioVal: null,
    }
  },
  created() {
    this.queryData(1);
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      materialService.getMaterialData(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    clickSelectMethod: function () {
      this.$emit('subCallMethod', this.selectRows[0]);
      this.restQueryForm();
    },
    //单选操作
    getTemplateRow(row) {
      this.selectRows = [];
      this.selectRows.push(row);
    },
    cancelSeleted: function () {
      this.radioVal = null;
      this.selectRows = null;
    }
  }, extends: dataTableUtils
}
</script>
<style scoped>
.query-btn-row {
  width: 30%;
  float: right;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}
.dialog-input {
  width: 40%;
}
.el-select {
  width: 100%;
}
</style>
